//el cierre diario se componde de 3 componentes:
// - CierreDiarioDatos
// - CierreDiarioOtrosDatos
// - CierreDiarioResumen
// Se muestra un componente Stepper de Material-ui que permite cambiuar de componente cuando el día está cerrado. 
// Si el día no está cerrado la navegación se hace mediante los botones de guartdar de cada uno de estos componentes.

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import StepButton from '@material-ui/core/StepButton';

//actions:
import { navigate, openDialog } from '../../actions';

//components:
import CierreDiarioDatos from './cierre_diario_datos';
import CierreDiarioOtrosDatos from './cierre_diario_otros_datos';
import CierreDiarioResumen from './cierre_diario_resumen';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    stepperContainer: {
        padding: '5px 25px'
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    alternativeLabel: {},
    labelContainer: {
        "& $alternativeLabel": {
            fontWeight: 600,
        }
    },
    icon: {
        color: 'silver',
    },
    textIcon: {
        color: 'white',
        fontWeight: 800
    }
});

// function getSteps() {
//     return ['Datos Cierre Diario', 'Otros Datos', 'Resumen y Cierre'];
// }

// function getStepContent(stepIndex) {
//     switch (stepIndex) {
//         case 0:
//             return <CierreDiarioDatos />;
//         case 1:
//             return <CierreDiarioOtrosDatos />;
//         case 2:
//             return <CierreDiarioResumen />;
//         default:
//             return 'Unknown stepIndex';
//     }
// }

class AccCierreDiario extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            first: true
        };
    };

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

    };

    componentDidUpdate = (prevProps, prevState) => {

        if (prevProps.navigation !== this.props.navigation) {
            if (this.state.activeStep !== 0)
                this.setState({ ...this.state, activeStep: 0 }); //if the user clicks the left drawer option we return to the first step
        }

    }

    getSteps = () => {
        return ['Datos Cierre Diario', 'Otros Datos', 'Resumen y Cierre'];
    };

    getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return <CierreDiarioDatos nextStep={this.handleNext} prevStep={this.handleBack} first={this.state.first}/>;
            case 1:
                return <CierreDiarioOtrosDatos nextStep={this.handleNext} prevStep={this.handleBack} first={this.state.first}/>;
            case 2:
                return <CierreDiarioResumen nextStep={this.handleNext} prevStep={this.handleBack} first={this.state.first}/>;
            default:
                return 'Unknown stepIndex';
        };
    };


    handleNext = () => {
        if (this.state.activeStep + 1 === this.getSteps().length) {
            this.setState(state => ({
                activeStep: 0,
                first: false
            }));
        }
        else {
            this.setState(state => ({
                activeStep: state.activeStep + 1,
                first: false
            }));
        }
    };

    handleStep = step => () => {
        this.setState({
            activeStep: step,
            first: false
        });
    };

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
            first: false
        }));
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
            first: false
        });
    };

    render() {
        const { classes } = this.props;
        const steps = this.getSteps();
        const { activeStep } = this.state;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar}></div>
                <Stepper activeStep={activeStep} nonLinear alternativeLabel className={classes.stepperContainer}>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            {this.props.centroDiaSelected.isDiaCerrado ?
                                <StepButton
                                    onClick={this.handleStep(index)}
                                    completed={true}
                                >
                                    {label}
                                </StepButton>
                                :
                                <StepLabel classes={{
                                    alternativeLabel: classes.alternativeLabel,
                                    labelContainer: classes.labelContainer
                                }}
                                    StepIconProps={{ classes: { root: classes.icon, text: classes.textIcon } }}>{label}</StepLabel>
                            }
                        </Step>
                    ))}
                </Stepper>
                <div>
                    {this.state.activeStep === steps.length ? (
                        <div>
                            <Typography className={classes.instructions}>All steps completed</Typography>
                            <Button onClick={this.handleReset}>Reset</Button>
                        </div>
                    ) : (
                            <div>
                                {this.getStepContent(activeStep)}
                                {/* <div>
                                    <Button
                                        disabled={activeStep === 0}
                                        onClick={this.handleBack}
                                        className={classes.backButton}
                                    >Back</Button>
                                    <Button variant="contained" color="primary" onClick={this.handleNext} disabled={this.props.centroDiaSelected.dia !== '' ? false : true}>
                                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                    </Button>
                                </div> */}
                            </div>
                        )}
                </div>
            </div>
        );
    };

};

AccCierreDiario.propTypes = {
    centroDiaSelected: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected,
        navigation: state.navigation
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate, openDialog
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(AccCierreDiario));
